module.exports = __webpack_public_path__ + "static/img/050504.9e9b4f88.png";